import { FC, ReactNode, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';
import { useAppStore } from 'src/context/AppStore';
import { PathURL } from 'src/utils/constants/path';
import { observer } from 'mobx-react-lite';
import useUserProfile from 'src/hooks/Users/useUserProfile';

interface SidebarLayoutProps {
  children?: ReactNode;
}

const MainWrapper = styled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;
        
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            padding-left: ${theme.sidebar.width};
        }
`
);

const MainContent = styled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
`
);

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const location = useLocation();

  const { profile, isPersisting } = useAppStore();
  const { mutationCurrentUser } = useUserProfile();
  const loggedIn = !!profile?.userId;

  useEffect(() => {
    if (profile?.userId) {
      mutationCurrentUser.mutateAsync();
    }
  }, [profile?.userId]);
  return (
    <>
      {isPersisting &&
        (loggedIn ? (
          <>
            <Sidebar />
            <MainWrapper>
              <Header />
              <MainContent>
                <Outlet />
              </MainContent>
            </MainWrapper>
          </>
        ) : (
          <Navigate to={PathURL.signin + '?from=' + location.pathname + location.search} replace={true} />
        ))}
    </>
  );
};

export default observer(SidebarLayout);
